import React, { Component } from "react";
import Header from "../ProductDetails/ProductHeader";
import GoogleMap from "./GoogleMap";
import Connect from "./Connect";
import { connect } from "react-redux";
import BranchesAccordion from "./BranchesAccordion";
import Review from "./Review";
import Pickup from "../AreaSelect/Pickup";
import {edit_quantity} from "../../store/actions";
import {registerGlanceView} from "../../store/actions/analytics";
import {fetchFeedbacks} from "../../store/actions/feedbacks";
import Feedbacks from "./Feedbacks/Feedbacks";

class index extends Component {
  state = {
    openAccordions: [0],
    loading: false,
  };
  addAccordion = (x) => {
    let newAccordions = this.state.openAccordions;
    newAccordions.push(x);
    this.setState({ openAccordions: newAccordions });
  };
  removeAccordion = (x) => {
    let newAccordions = this.state.openAccordions;
    newAccordions = newAccordions.filter((a) => a != x);
    this.setState({ openAccordions: newAccordions });
  };
  fetchFeedbacks = async () => {
    if(this.props.feedbacks.length === 0){
      this.setState({loading: true});
      await this.props.fetchFeedbacks();
      this.setState({loading: false});
    }
  }
  componentDidMount = () => {
    window.scrollTo(0, 0);
    if(this.props.settings.enable_feedback_on_website && this.props.settings.enable_feedback){
          this.fetchFeedbacks();
    }
  };

  render() {
    const settings = this.props.settings;
    return (
      <div
        className="p-0"
        style={{ backgroundColor: "#F5F5F5", minHeight: "100vh" }}
      >
        <Header onBack={() => this.props.history.replace("/")} />

        <div style={{ marginTop: 80 }}>
          <Pickup listOnly />
        </div>
        {settings.enable_feedback && (
            <>
              <Review/>
              {this.props.feedbacks.length !== 0 && settings.enable_feedback_on_website && (<Feedbacks loading={this.state.loading}/>)}
            </>
        )}
        {(settings.link_instagram ||
          settings.link_whatsapp ||
          settings.link_phone ||
          settings.link_site ||
          settings.link_call_center ||
          settings.contact_email) && <Connect />}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    store: state.store.store,
    settings: state.store.store.settings,
    branches: state.store.store.branches,
    feedbacks: state.feedbacks.feedbacks,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchFeedbacks: () =>
      dispatch(fetchFeedbacks()),
  };
};
export default connect(mapStateToProps,mapDispatchToProps)(index);
